import { Flow_0_0_2 } from '@flexus/core';

export const SIL_41: Flow_0_0_2 = {
	id: '41',
	name: 'job_cancelled_notification',
	itemType: 'flow',
	header: {
		title: '',
		controls: () => () => []
	},
	footer: {
		type: 'node_nav'
	},
	instructions: {
		editRoles: {
			0: '--'
		},
		viewRoles: {
			0: 'Wait for SP to confirm cancellation'
		}
	},
	startNode: '',
	nodes: {}
};
